





































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListNohinsaki from '@/components/common/search/ListNohinsaki.vue';
import { API_SEARCH_NOHINSAKI } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlNohinsaki',
  components: {
    CtrlSearchBtn,
    CtrlNumTxt,
    ListNohinsaki,
  },
  props: {
    jigyoshoCd: {
      type: Number,
      required: true,
    },
    tokuisakiCd: {
      type: Number,
      required: true,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '納品先',
    },
    widthCd: {
      type: Number,
      default: 63, //42,
    },
    widthName: {
      type: Number,
      default: 510,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_NOHINSAKI,
    listNohinsakiShow: false,
    nohinsakiCd: 0,
    nohinsakiMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { nohinsakiCd, nohinsakiMei } = item;
      this.nohinsakiCd = nohinsakiCd;
      this.nohinsakiMei = nohinsakiMei;
      this.listNohinsakiShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listNohinsakiShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.nohinsakiCd = value;
      if (value) {
        this.getNohinsakiItem();
      } else {
        this.nohinsakiMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ nohinsakiCd: this.nohinsakiCd });
      }
    },
    getNohinsakiItem() {
      axios
        .get(API_SEARCH_NOHINSAKI, {
          params: {
            nohinsakiCd: this.nohinsakiCd,
            jigyoshoCd: this.jigyoshoCd,
            tokuisakiCd: this.tokuisakiCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.nohinsakiMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ nohinsakiCd: this.nohinsakiCd });
            return;
          }
          this.errors = clearNoDataError();
          const { nohinsakiMei } = res.data.responseData[0];
          this.nohinsakiMei = nohinsakiMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [nohinsakiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.nohinsakiCd': {
      handler(newValue) {
        if (+newValue === +this.nohinsakiCd) return;
        this.nohinsakiCd = +newValue;
        if (newValue) {
          this.getNohinsakiItem();
        } else {
          this.nohinsakiMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.nohinsakiCd) {
      this.nohinsakiCd = +this.$attrs.nohinsakiCd;
    }
  },
});
